import React from "react";
import { Notification } from "../Notification";
const AlertsAndNotifications = ({
  notifications,
  deleteNotificationById
}: {
  notifications: readonly Notification[];
  deleteNotificationById: (messageId: number) => void;
}) => {
  return <div data-testid="platinum-alerts-and-notifications" className="relative lt:h-auto max-h-40 bg-white rounded border border-gray-200 border-solid flex-0 w-full lt:w-1/3 flex flex-col justify-start itmes-start overflow-hidden" data-sentry-component="AlertsAndNotifications" data-sentry-source-file="index.tsx">
      <div className="absolute inset-x-0 bottom-0 h-2 bg-gradient-to-t from-white to-transparent-t z-10" />
      <h4 className="text-sm font-semibold text-gray-800 leading-none mb-1 px-4 pt-2">
        Messages &amp; Alerts
      </h4>
      <div className="flex flex-col justify-start items-start overflow-y-auto">
        {notifications.map(notification => <div data-testid="platinum-notification" className="relative group w-full" key={notification.id}>
            {notification.isDeletableByUser && <button onClick={() => deleteNotificationById(notification.id)} data-testid="delete-notification-button" type="button" aria-label="Close" className="absolute top-0 right-0 hidden group-hover:block bg-transparent border-none z-10 cursor-pointer">
                <svg aria-hidden="true" className="w-4 h-4 text-gray-900 m-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path fill="currentColor" d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                </svg>
              </button>}
            <div className="relative w-full group-hover:bg-gray-50">
              <div className="px-4 py-1">
                {notification.link ? <a className="" href={notification.link}>
                    <h5 className="flex flex-row justify-start items-center text-gray-800 text-sm font-semibold mb-px">
                      {notification.type === "general" ? <div className="w-2 h-2 rounded-full bg-purple-600 mr-1" /> : <div className="w-2 h-2 rounded-full bg-blue-600 mr-1" />}
                      {notification.formattedDateCreated}
                    </h5>
                    <p className="text-sm font-regular leading-tight mb-0 text-gray-700">
                      {notification.message}
                    </p>
                  </a> : <>
                    <h5 className="flex flex-row justify-start items-center text-gray-800 text-sm font-semibold mb-px">
                      {notification.type === "general" ? <div className="w-2 h-2 rounded-full bg-purple-600 mr-1" /> : <div className="w-2 h-2 rounded-full bg-blue-600 mr-1" />}
                      {notification.formattedDateCreated}
                    </h5>
                    <p className="text-sm font-regular leading-tight mb-0 text-gray-700">
                      {notification.message}
                    </p>
                  </>}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};
export default AlertsAndNotifications;